// Copyright (c) 2016 Deere & Company

export default Object.freeze({
    ADD_CLAIM_MCC_FOLLOWUP_ADDITIONAL_REPAIR: 'ADD_CLAIM_MCC_FOLLOWUP_ADDITIONAL_REPAIR',
    ADD_CLAIM_MCC_FOLLOWUP_FILE: 'ADD_CLAIM_MCC_FOLLOWUP_FILE',
    COPY_CLAIM_MCC_FOLLOWUP: 'COPY_CLAIM_MCC_FOLLOWUP',
    DELETE_CLAIM_MCC_FOLLOWUP_FILE: 'DELETE_CLAIM_MCC_FOLLOWUP_FILE',
    RESET_CLAIM_MCC_FOLLOWUP: 'RESET_CLAIM_MCC_FOLLOWUP',
    RESET_CLAIM_MCC_FOLLOWUP_CONFIRMATION_MODAL: 'RESET_CLAIM_MCC_FOLLOWUP_CONFIRMATION_MODAL',
    RESET_CLAIM_MCC_FOLLOWUP_FORM_VALIDATION: 'RESET_CLAIM_MCC_FOLLOWUP_FORM_VALIDATION',
    RESET_CLAIM_MCC_FOLLOWUP_PRODUCT_DETAILS: 'RESET_CLAIM_MCC_FOLLOWUP_PRODUCT_DETAILS',
    REVISE_CLAIM_MCC_FOLLOWUP: 'REVISE_CLAIM_MCC_FOLLOWUP',
    SET_CLAIM_MCC_FOLLOWUP: 'SET_CLAIM_MCC_FOLLOWUP',
    UPDATE_CLAIM_MCC_FOLLOWUP_CLAIM_QUESTIONS: 'UPDATE_CLAIM_MCC_FOLLOWUP_CLAIM_QUESTIONS',
    UPDATE_CLAIM_MCC_FOLLOWUP_CLAIM_TYPES: 'UPDATE_CLAIM_MCC_FOLLOWUP_CLAIM_TYPES',
    UPDATE_CLAIM_MCC_FOLLOWUP_CONFIRMATION_MODAL: 'UPDATE_CLAIM_MCC_FOLLOWUP_CONFIRMATION_MODAL',
    UPDATE_CLAIM_MCC_FOLLOWUP_CONTACT_DATE: 'UPDATE_CLAIM_MCC_FOLLOWUP_CONTACT_DATE',
    UPDATE_CLAIM_MCC_FOLLOWUP_CREATE_CLAIM_MODAL_VISIBILITY: 'UPDATE_CLAIM_MCC_FOLLOWUP_CREATE_CLAIM_MODAL_VISIBILITY',
    UPDATE_CLAIM_MCC_FOLLOWUP_CUSTOMER_DETAILS: 'UPDATE_CLAIM_MCC_FOLLOWUP_CUSTOMER_DETAILS',
    UPDATE_CLAIM_MCC_FOLLOWUP_E_MAIL: 'UPDATE_CLAIM_MCC_FOLLOWUP_E_MAIL',
    UPDATE_CLAIM_MCC_FOLLOWUP_FILE: 'UPDATE_CLAIM_MCC_FOLLOWUP_FILE',
    UPDATE_CLAIM_MCC_FOLLOWUP_FIRST_NAME: 'UPDATE_CLAIM_MCC_FOLLOWUP_FIRST_NAME',
    UPDATE_CLAIM_MCC_FOLLOWUP_FORM_VALIDATION: 'UPDATE_CLAIM_MCC_FOLLOWUP_FORM_VALIDATION',
    UPDATE_CLAIM_MCC_FOLLOWUP_GOODS_INSTALLATION_VAT: 'UPDATE_CLAIM_MCC_FOLLOWUP_GOODS_INSTALLATION_VAT',
    UPDATE_CLAIM_MCC_FOLLOWUP_GOODS_INSTALLATION_VAT_OPTIONS: 'UPDATE_CLAIM_MCC_FOLLOWUP_GOODS_INSTALLATION_VAT_OPTIONS',
    UPDATE_CLAIM_MCC_FOLLOWUP_IS_ACTION_BUTTON_DISABLED: 'UPDATE_CLAIM_MCC_FOLLOWUP_IS_ACTION_BUTTON_DISABLED',
    UPDATE_CLAIM_MCC_FOLLOWUP_IS_COPIED: 'UPDATE_CLAIM_MCC_FOLLOWUP_IS_COPIED',
    UPDATE_CLAIM_MCC_FOLLOWUP_IS_EDITABLE: 'UPDATE_CLAIM_MCC_FOLLOWUP_IS_EDITABLE',
    UPDATE_CLAIM_MCC_FOLLOWUP_LAST_NAME: 'UPDATE_CLAIM_MCC_FOLLOWUP_LAST_NAME',
    UPDATE_CLAIM_MCC_FOLLOWUP_MCC_QUESTIONS: 'UPDATE_CLAIM_MCC_FOLLOWUP_MCC_QUESTIONS',
    UPDATE_CLAIM_MCC_FOLLOWUP_METHOD_OF_CONTACT: 'UPDATE_CLAIM_MCC_FOLLOWUP_METHOD_OF_CONTACT',
    UPDATE_CLAIM_MCC_FOLLOWUP_METHOD_OF_CONTACT_OPTIONS: 'UPDATE_CLAIM_MCC_FOLLOWUP_METHOD_OF_CONTACT_OPTIONS',
    UPDATE_CLAIM_MCC_FOLLOWUP_MODAL_MODE: 'UPDATE_CLAIM_MCC_FOLLOWUP_MODAL_MODE',
    UPDATE_CLAIM_MCC_FOLLOWUP_PIN: 'UPDATE_CLAIM_MCC_FOLLOWUP_PIN',
    UPDATE_CLAIM_MCC_FOLLOWUP_PRODUCT_DETAILS: 'UPDATE_CLAIM_MCC_FOLLOWUP_PRODUCT_DETAILS',
    UPDATE_CLAIM_MCC_FOLLOWUP_QUESTIONS_REQUIRED_OPTIONS: 'UPDATE_CLAIM_MCC_FOLLOWUP_QUESTIONS_REQUIRED_OPTIONS',
    UPDATE_CLAIM_MCC_FOLLOWUP_QUESTION_CHOICE: 'UPDATE_CLAIM_MCC_FOLLOWUP_QUESTION_CHOICE',
    UPDATE_CLAIM_MCC_FOLLOWUP_RELATIONSHIP: 'UPDATE_CLAIM_MCC_FOLLOWUP_RELATIONSHIP',
    UPDATE_CLAIM_MCC_FOLLOWUP_RELATIONSHIP_OPTIONS: 'UPDATE_CLAIM_MCC_FOLLOWUP_RELATIONSHIP_OPTIONS',
    UPDATE_CLAIM_MCC_FOLLOWUP_RESPONSIBLE_ACCOUNT: 'UPDATE_CLAIM_MCC_FOLLOWUP_RESPONSIBLE_ACCOUNT',
    UPDATE_CLAIM_MCC_FOLLOWUP_SELLING_DEALER: 'UPDATE_CLAIM_MCC_FOLLOWUP_SELLING_DEALER',
    UPDATE_CLAIM_MCC_FOLLOWUP_STICKY_HEADER_VISIBILITY: 'UPDATE_CLAIM_MCC_FOLLOWUP_STICKY_HEADER_VISIBILITY',
    UPDATE_CLAIM_MCC_FOLLOWUP_TEMPORARY_OBJECT_KEY: 'UPDATE_CLAIM_MCC_FOLLOWUP_TEMPORARY_OBJECT_KEY',
    UPDATE_CLAIM_MCC_FOLLOWUP_WORK_ORDER_ONE: 'UPDATE_CLAIM_MCC_FOLLOWUP_WORK_ORDER_ONE',
    UPDATE_CLAIM_MCC_FOLLOWUP_WORK_ORDER_TWO: 'UPDATE_CLAIM_MCC_FOLLOWUP_WORK_ORDER_TWO'
});



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-customer-followup/action-list.js